import {
  BULK_ASSIGN_EMPLOYEE_DESIGNATION_FAIL,
  BULK_ASSIGN_EMPLOYEE_DESIGNATION_REQUEST,
  BULK_ASSIGN_EMPLOYEE_DESIGNATION_SUCCESS,
  CREATE_EMPLOYEE_DESIGNATION_FAIL,
  CREATE_EMPLOYEE_DESIGNATION_REQUEST,
  CREATE_EMPLOYEE_DESIGNATION_SUCCESS,
  DELETE_EMPLOYEE_DESIGNATION_FAIL,
  DELETE_EMPLOYEE_DESIGNATION_REQUEST,
  DELETE_EMPLOYEE_DESIGNATION_SUCCESS,
  GET_ALL_EMPLOYEE_DESIGNATION_FAIL,
  GET_ALL_EMPLOYEE_DESIGNATION_REQUEST,
  GET_ALL_EMPLOYEE_DESIGNATION_SUCCESS,
  UPDATE_EMPLOYEE_DESIGNATION_FAIL,
  UPDATE_EMPLOYEE_DESIGNATION_REQUEST,
  UPDATE_EMPLOYEE_DESIGNATION_SUCCESS,
} from "../../types/admin/employeeDesignationTypes";

export const getAllEmployeeDesignationReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_EMPLOYEE_DESIGNATION_REQUEST:
      return {
        ...state,
        Loading: true,
      };
    case GET_ALL_EMPLOYEE_DESIGNATION_SUCCESS:
      return {
        ...state,
        Loading: false,
        getAllEmployeeDesignationInfo: payload,
        getAllEmployeeDesignationError: "",
      };
    case GET_ALL_EMPLOYEE_DESIGNATION_FAIL:
      return {
        ...state,
        Loading: false,
        getAllEmployeeDesignationInfo: [],
        getAllEmployeeDesignationError: payload,
      };
    default:
      return state;
  }
};

export const updateEmployeeDesignationReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_EMPLOYEE_DESIGNATION_REQUEST:
      return {
        ...state,
        updateEmployeeDesignationLoading: true,
      };
    case UPDATE_EMPLOYEE_DESIGNATION_SUCCESS:
      return {
        ...state,
        updateEmployeeDesignationLoading: false,
        updateEmployeeDesignationInfo: payload,
        updateEmployeeDesignationError: "",
      };
    case UPDATE_EMPLOYEE_DESIGNATION_FAIL:
      return {
        ...state,
        updateEmployeeDesignationLoading: false,
        updateEmployeeDesignationInfo: [],
        updateEmployeeDesignationError: payload,
      };
    default:
      return state;
  }
};
export const createEmployeeDesignationReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case CREATE_EMPLOYEE_DESIGNATION_REQUEST:
      return {
        ...state,
        createEmployeeDesignationLoading: true,
      };
    case CREATE_EMPLOYEE_DESIGNATION_SUCCESS:
      return {
        ...state,
        createEmployeeDesignationLoading: false,
        createEmployeeDesignationInfo: payload,
        createEmployeeDesignationError: "",
      };
    case CREATE_EMPLOYEE_DESIGNATION_FAIL:
      return {
        ...state,
        createEmployeeDesignationLoading: false,
        createEmployeeDesignationInfo: [],
        createEmployeeDesignationError: payload,
      };
    default:
      return state;
  }
};

export const deleteEmployeeDesignationReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case DELETE_EMPLOYEE_DESIGNATION_REQUEST:
      return {
        ...state,
        Loading: true,
      };
    case DELETE_EMPLOYEE_DESIGNATION_SUCCESS:
      return {
        ...state,
        Loading: false,
        deleteEmployeeDesignationInfo: payload,
        deleteEmployeeDesignationError: "",
      };
    case DELETE_EMPLOYEE_DESIGNATION_FAIL:
      return {
        ...state,
        Loading: false,
        deleteEmployeeDesignationInfo: [],
        deleteEmployeeDesignationError: payload,
      };
    default:
      return state;
  }
};

export const bulkAssignEmployeeDesignationReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case BULK_ASSIGN_EMPLOYEE_DESIGNATION_REQUEST:
      return {
        ...state,
        bulkAssignEmployeeDesignationLoading: true,
      };
    case BULK_ASSIGN_EMPLOYEE_DESIGNATION_SUCCESS:
      return {
        ...state,
        bulkAssignEmployeeDesignationLoading: false,
        bulkAssignEmployeeDesignationInfo: payload,
        bulkAssignEmployeeDesignationError: "",
      };
    case BULK_ASSIGN_EMPLOYEE_DESIGNATION_FAIL:
      return {
        ...state,
        bulkAssignEmployeeDesignationLoading: false,
        bulkAssignEmployeeDesignationInfo: [],
        bulkAssignEmployeeDesignationError: payload,
      };
    default:
      return state;
  }
};
